// import Vue from 'vue'
import loginEn from './login.vue';
// import loginZh from './loginZh.vue';
// import { i18n, DEFAULT_LANG } from '@/locales/index';
// // import VueI18n from 'vue-i18n';
// // import zh from '@/config/zh.json';
// // import en from '@/config/en.json';

// // Vue.use(VueI18n);
// // const DEFAULT_LANG = 'en';
// // const locales = {
// //   'zh-cn': zh,
// //   en,
// // };
// // const i18n = new VueI18n({
// //   locale: DEFAULT_LANG,
// //   messages: locales,
// // });

// const login = DEFAULT_LANG ? loginZh : loginEn;

// const loginDialog = Vue.extend(login);
// let instance;
// login.open = function(loginSuccess) {
//     if(!instance){
//       instance = new loginDialog({
//           i18n
//       }).$mount()
//     }
//     document.body.appendChild(instance.$el);
//     Vue.nextTick(() => {
//       instance.open(loginSuccess);
//     });
//   };

// login.close = function(){
//     Vue.nextTick(() => {
//         instance.$destroy()
//         instance = null;
//     });
// }
// export default login



export default{
  install(Vue, i18n){
    // const login = i18n.locale == 'en'? loginEn : loginZh;
    const login = loginEn;
    const loginDialog = Vue.extend(login);
    let instance;
    login.open = function(loginSuccess) {
        if(!instance){
          instance = new loginDialog({
              i18n
          }).$mount()
        }
        document.body.appendChild(instance.$el);
        Vue.nextTick(() => {
          instance.open(loginSuccess);
        });
      };
      
    login.close = function(){
        Vue.nextTick(() => {
            instance.$destroy()
            instance = null;
        });
    }

    Vue.prototype.$login = login;
  }
}